import {
  PerdcompSituacao,
  PerdcompTipoCredito,
  PerdcompTipoDocumento,
  PerDecomp,
} from "types/OnDemand.types";

export type PerDecompSummary = {
  valid: PerDecomp[];
  ipi: any;
  pis: any;
  confins: any;
  snirpj: any;
  sncsll: any;
  snReintegra: any;
  pagementoMaiorIndevido: any;
  salarioFamiliaMaternidade: any;
};

const getValidRows = (percomp: PerDecomp) => {
  const tipoCredito = Object.values(PerdcompTipoCredito).find(
    (val) => val === percomp.tipoCredito,
  );
  const tipoDocument = Object.values(PerdcompTipoDocumento).find(
    (val) => val === percomp.tipoDocumento,
  );

  const validTipoDocs = [
    PerdcompTipoDocumento.PedidoDeRessarcimento,
    PerdcompTipoDocumento.PedidoDeRestituicao,
    PerdcompTipoDocumento.PedidodeReembolso,
  ];

  const validTipoCredito = [
    PerdcompTipoCredito.RessarcimentoDeIPI,
    PerdcompTipoCredito.PISPASEPNaoCumulativo,
    PerdcompTipoCredito.CofinsNaoCumulativa,
    PerdcompTipoCredito.ContribuicaoPrevidenciariaIndevidaOuAMaior,
    PerdcompTipoCredito.SaldoNegativoDeCSLL,
    PerdcompTipoCredito.SaldoNegativoDeIRPJ,
    PerdcompTipoCredito.SalarioFamiliaSalarioMaternidade,
  ];

  return (
    validTipoCredito.includes(tipoCredito) &&
    validTipoDocs.includes(tipoDocument)
  );
};

export const useSearchPerdecompSummary = (percomp: PerDecomp[]) => {
  const validRows = percomp.filter(getValidRows);
  return {
    valid: validRows,
    ipi: validRows.filter(
      (r) => r.tipoCredito == PerdcompTipoCredito.RessarcimentoDeIPI,
    ),
    pis: validRows.filter(
      (r) => r.tipoCredito == PerdcompTipoCredito.PISPASEPNaoCumulativo,
    ),
    confins: validRows.filter(
      (r) => r.tipoCredito == PerdcompTipoCredito.CofinsNaoCumulativa,
    ),
    pagementoMaiorIndevido: validRows.filter(
      (r) => r.tipoCredito == PerdcompTipoCredito.PagamentoIndevidoOuAMaior,
    ),
    sncsll: validRows.filter(
      (r) => r.tipoCredito == PerdcompTipoCredito.SaldoNegativoDeCSLL,
    ),
    snirpj: validRows.filter(
      (r) => r.tipoCredito == PerdcompTipoCredito.SaldoNegativoDeIRPJ,
    ),
    salarioFamiliaMaternidade: validRows.filter(
      (r) =>
        r.tipoCredito == PerdcompTipoCredito.SalarioFamiliaSalarioMaternidade,
    ),
  } as PerDecompSummary;
};
